module.exports = __webpack_public_path__ + "static/media/menosph.f9089184.pdf";